import { makeObservable, observable } from "mobx";
import { MSTeamsPanel } from "./msteams/component/MSTeamsStore";
import { WidgetPanel } from "./slack/component/SlackStore";

export interface User {
	id: string;
	name: string;
}

export interface Team { }

export interface Channel { }

export const MESSAGE_TIME_FORMAT: Intl.DateTimeFormatOptions = { hour: "numeric", minute: "numeric" };

export class UserProvider<T> {
	private readonly _users: T[];

	/** users */
	get users(): T[] {
		return this._users;
	}

	constructor(users: T[]) {
		this._users = users;
	}
}

export type ValueOf<T> = T[keyof T];

export class ChannelItem<T> {
	readonly displayName: string;
	readonly id: string;
	readonly membershipType: T;
	readonly webUrl: string;
	@observable selected: boolean = false;

	constructor(id: string, displayName: string, membershipType: T, webUrl: string) {
		makeObservable(this);
		this.id = id;
		this.displayName = displayName;
		this.membershipType = membershipType;
		this.webUrl = webUrl;
	}
}

export type Panel = WidgetPanel | MSTeamsPanel;